/// <amd-module name="SuiteCommerce.GiftCertificate.Group.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.Group.Model", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificates.Collection"], function (require, exports, Backbone_1, GiftCertificate_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GroupModel = void 0;
    var GroupModel = /** @class */ (function (_super) {
        __extends(GroupModel, _super);
        function GroupModel(attributes, options) {
            var _this = _super.call(this, attributes, options) || this;
            if (attributes) {
                attributes.giftCertificates.forEach(function (giftCertificate) {
                    if (!_this.maxPrice || giftCertificate.price > _this.maxPrice) {
                        _this.maxPrice = giftCertificate.price;
                        _this.maxPriceStr = giftCertificate.priceStr;
                    }
                    if (!_this.minPrice || giftCertificate.price < _this.minPrice) {
                        _this.minPrice = giftCertificate.price;
                        _this.minPriceStr = giftCertificate.priceStr;
                    }
                });
            }
            return _this;
        }
        Object.defineProperty(GroupModel.prototype, "giftCertificates", {
            get: function () {
                return this.get('giftCertificates');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GroupModel.prototype, "id", {
            get: function () {
                return this.get('recordid');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GroupModel.prototype, "isInactive", {
            get: function () {
                return this.get('isinactive');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GroupModel.prototype, "name", {
            get: function () {
                return this.get('name');
            },
            enumerable: false,
            configurable: true
        });
        GroupModel.prototype.parse = function (rawData) {
            var parsedData = {
                recordid: rawData.recordid,
                name: rawData.name,
                isinactive: rawData.isinactive,
                giftCertificates: null,
            };
            parsedData.giftCertificates = new GiftCertificate_Collection_1.GiftCertificateCollection(rawData.giftCertificates);
            return parsedData;
        };
        return GroupModel;
    }(Backbone_1.Model));
    exports.GroupModel = GroupModel;
});
